import React, { forwardRef } from 'react';
import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';

const Advertisement = forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => (
  <SvgIcon {...props} ref={ref} viewBox="0 0 24 24">
    <g clipPath="url(#clip0_2545_1114)">
      <path d="M4 4H20C21.1 4 22 4.9 22 6V18C22 19.1 21.1 20 20 20H4C2.9 20 2 19.1 2 18V6C2 4.9 2.9 4 4 4ZM4 6V18H20V6H4Z" />
      <path d="M12.6 7V17H16.6C17.7 17 18.6 16.1 18.6 15V9C18.6 7.9 17.7 7 16.6 7H12.6ZM14.6 9H16.6V15H14.6V9ZM7.4 7C6.3 7 5.4 7.9 5.4 9V17H7.4V13H9.4V17H11.4V9C11.4 7.9 10.5 7 9.4 7H7.4ZM7.4 9H9.4V11H7.4V9Z" />
    </g>
    <defs>
      <clipPath id="clip0_2545_1114">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </SvgIcon>
));

Advertisement.displayName = 'Advertisement';

export default Advertisement;
